export default "__VITE_ASSET__CLKSMnYM__"